export default __webpack_public_path__ + "static/media/kitchen1-1920w.524aeca5.webp";